import React from "react";
import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";
import sanityConfig from "../../../config/sanity";
import clsx from "clsx";

const Image = ({ input }) => {
  // console.log(input);
  const imageData = getGatsbyImageData(
    input.asset,
    { maxWidth: 1000 },
    sanityConfig.sanity
  );
  // console.log(input.asset.metadata);

  return (
    <section
      className={clsx(
        "image",
        input.asset.metadata.hasAlpha ? "has-alpha" : ""
      )}>
      <GatsbyImage
        image={imageData}
        alt=''
        placeholder='blurred'
        objectFit='contain'
        // objectPosition='100% 50%'
        objectPosition='100% 0%'
      />
    </section>
  );
};

export default Image;
